import { render, staticRenderFns } from "./ChatterProjectAvailableUserGrid.vue?vue&type=template&id=689c2006"
import script from "./ChatterProjectAvailableUserGrid.vue?vue&type=script&lang=js"
export * from "./ChatterProjectAvailableUserGrid.vue?vue&type=script&lang=js"
import style0 from "./ChatterProjectAvailableUserGrid.vue?vue&type=style&index=0&id=689c2006&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports